import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

export interface UseEnduserOrdersOptions {
  limit?: number;
  /** Whether to enable the query (defaults to true) */
  enabled?: boolean;
}

export function useEnduserOrders(options: UseEnduserOrdersOptions = {}) {
  const { limit = 50, enabled = true } = options;

  const query = useTellescopeInfiniteQuery({
    model: "enduser_orders",
    method: "getSome",
    request: {
      filter: {},
      limit,
    },
    select: (data) => data.pages.flat(),
    enabled,
  });

  const allOrders = query.data ?? [];

  // Sort by updatedAt (most recent first)
  const sortedOrders = [...allOrders].sort((a, b) => {
    const aTime = new Date(a.updatedAt).getTime();
    const bTime = new Date(b.updatedAt).getTime();
    return bTime - aTime;
  });

  return {
    ...query,
    orders: sortedOrders,
  };
}
